// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2cG_A","actions":"GroupTable_actions__pxvRl","deleteModalFooter":"GroupTable_deleteModalFooter__3nQbs"};